const EmployeesDetails = () => {
  return (
    <div className=" w-full">
      <div className="rounded-xl border border-gray-200 bg-white p-4">
        <div className="grid h-12 grid-cols-3">
          <div className="text-center">
            <div className="mb-1 text-[11px] font-medium uppercase tracking-wide text-[#A3A3A3]">C-SUITE</div>
            <div className="text-base font-medium text-gray-950">146</div>
          </div>

          <div className="border-x border-gray-200 text-center">
            <div className="mb-1 text-xs font-medium uppercase tracking-wide text-gray-400">VPS</div>
            <div className="text-base font-medium text-gray-950">296</div>
          </div>

          <div className="text-center">
            <div className="mb-1 text-xs font-medium uppercase tracking-wide text-gray-400">DIRECTORS</div>
            <div className="text-base font-medium text-gray-950">1432</div>
          </div>
        </div>

        <div className="my-2 border-t border-gray-200"></div>

        <div className="grid h-12 grid-cols-2">
          <div className="text-center">
            <div className="mb-1 text-xs font-medium uppercase tracking-wide text-gray-400">MANAGERS</div>
            <div className="text-base font-medium text-gray-950">6800</div>
          </div>

          <div className="border-l border-gray-200 text-center">
            <div className="mb-1 text-xs font-medium uppercase tracking-wide text-gray-400">SENIORS</div>
            <div className="text-base font-medium text-gray-950">5298</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmployeesDetails
